import { canvasPanelClassNames } from "../canvasTheme";
import type { DecimalSeparator, DrawingUnit, SettingsPanelProps } from "../settingsPanelTypes";
import { SelectField } from "./SettingsPanelFields";

const drawingUnitOptions: Array<{ value: DrawingUnit; label: string }> = [
  { value: "mm", label: "Millimeters" },
  { value: "cm", label: "Centimeters" },
  { value: "m", label: "Meters" },
  { value: "in", label: "Inches" },
  { value: "ft", label: "Feet" },
];

const decimalSeparatorOptions: Array<{ value: DecimalSeparator; label: string }> = [
  { value: "comma", label: "Comma" },
  { value: "point", label: "Point" },
];

type UnitsSettingsPageProps = Pick<
  SettingsPanelProps,
  "drawingUnit" | "onDrawingUnitChange" | "decimalSeparator" | "onDecimalSeparatorChange"
>;

export function UnitsSettingsPage({
  drawingUnit,
  onDrawingUnitChange,
  decimalSeparator,
  onDecimalSeparatorChange,
}: UnitsSettingsPageProps) {
  return (
    <div className={canvasPanelClassNames.sectionStack}>
      <h4 className={canvasPanelClassNames.sectionTitle}>Units</h4>
      <SelectField
        label="Drawing Units"
        value={drawingUnit}
        options={drawingUnitOptions}
        onChange={onDrawingUnitChange}
      />
      <SelectField
        label="Decimal Separator"
        value={decimalSeparator}
        options={decimalSeparatorOptions}
        onChange={onDecimalSeparatorChange}
      />
    </div>
  );
}
